(function() { module.exports = window["Next"]["Box"]; }());